module.exports = __webpack_public_path__ + "assets/img/bind-phone-close.3ed45d51.png";